import React from 'react';

import GovTrustPass from './assets/gov-trust-success.png';
import GovTrustError from './assets/gov-trust-error.png';
import Page from './components/Page';
import isSuccessfulLink from './api/isSuccessfulLink';
import { TRANSLATION_ENG } from './translation';
import { getSuccessAppLaunchUrl } from './getSuccessAppLaunchUrl';
import { getFailAppLaunchUrl } from './getFailAppLaunchUrl';

function App() {
  if (isSuccessfulLink(window.location.search)) {
    return (
      <Page
        hsbcLogoAlt={TRANSLATION_ENG.success.hsbcLogoAlt}
        sectionImgSrc={GovTrustPass}
        sectionText={TRANSLATION_ENG.success.sectionText}
        headerText={TRANSLATION_ENG.success.headerText}
        buttonText={TRANSLATION_ENG.success.buttonText}
        appLaunchUrl={getSuccessAppLaunchUrl()}
      />
    );
  }

  return (
    <Page
      hsbcLogoAlt={TRANSLATION_ENG.error.hsbcLogoAlt}
      sectionImgSrc={GovTrustError}
      sectionText={TRANSLATION_ENG.error.sectionText}
      headerText={TRANSLATION_ENG.error.headerText}
      buttonText={TRANSLATION_ENG.error.buttonText}
      appLaunchUrl={getFailAppLaunchUrl()}
    />
  );
}

export default App;
